// src/pages/BlogPostPage.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL;

const BlogPostPage = () => {
  // Değişiklik 1: 'blogId' yerine backend'deki path parametresiyle uyumlu 'post_id' kullanalım (isteğe bağlı ama daha tutarlı)
  // App.js'deki Route path'ini de <Route path="/blog/:blogId" element={<BlogPostPage />} /> olarak güncellemen gerekir.
  const { blogId } = useParams(); 
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        // Değişiklik 2: API endpoint'ini backend'e uygun hale getiriyoruz.
        // ESKİ: /api/blogs/${blogId}
        // YENİ: /api/v1/blog/posts/${blogId}
        const response = await axios.get(`${API_URL}/posts/${blogId}`);
        setPost(response.data);
      } catch (err) {
        console.error(err);
        if (err.response && err.response.status === 404) {
          setError("Aradığınız blog yazısı bulunamadı.");
        } else {
          setError("Yazı yüklenirken bir sunucu hatası oluştu.");
        }
      } finally {
        setLoading(false);
      }
    };
    if (blogId) fetchPost();
  }, [blogId]); // Dependency array'i de blogId olarak güncelledik.

  // --- Geri kalan kodda bir değişiklik yapmaya gerek yok, hepsi dinamik olarak çalışacaktır ---

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen bg-gray-900">
        <div className="w-16 h-16 border-4 border-t-4 border-indigo-500 rounded-full animate-spin"></div>
      </div>
    );

  if (error)
    return (
      <div className="flex flex-col justify-center items-center h-screen bg-gray-900 text-red-500">
        <p className="text-xl mb-4">{error}</p>
        <Link to="/blog" className="text-indigo-400 hover:underline flex items-center space-x-2">
          <ArrowLeft size={18} />
          <span>Bloga Geri Dön</span>
        </Link>
      </div>
    );

  if (!post) return null; // Post yoksa veya yükleniyorsa hata/loading ekranı zaten gösterilir.

  return (
    <div className="min-h-screen bg-gray-900 text-white font-inter py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <Link to="/blog" className="text-gray-400 hover:text-indigo-400 flex items-center space-x-2 mb-8">
          <ArrowLeft size={20} />
          <span>Tüm Yazılar</span>
        </Link>

        {/* Not: Veritabanından gelen verilerde image_url olmayabilir, buna karşı bir fallback eklenebilir. */}
        <img src={post.image_url.startsWith('/') ? post.image_url : `/${post.image_url}`} alt={post.title} className="w-full h-80 md:h-96 object-cover rounded-xl mb-8 shadow-lg" />

        <header className="mb-8">
          <h1 className="text-4xl sm:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-teal-300 to-indigo-400 mb-4 leading-tight">
            {post.title}
          </h1>
          <div className="flex flex-wrap items-center text-gray-400 text-sm gap-x-4 gap-y-2">
            <span>Yazar: <span className="text-indigo-400 font-medium">{post.author}</span></span>
            <span className="hidden sm:inline">|</span>
            {/* Tarih null olabilir diye kontrol eklemek iyi bir pratik */}
            {post.date && <span>{new Date(post.date).toLocaleDateString("tr-TR", { day: 'numeric', month: 'long', year: 'numeric' })}</span>}
            <span className="hidden sm:inline">|</span>
            {post.read_time && <span>{post.read_time}</span>}
          </div>
        </header>

        {/*
          UYARI: dangerouslySetInnerHTML kullanımı, eğer 'content' verisi 
          kullanıcıdan alınıyorsa ve backend'de sanitize edilmiyorsa 
          XSS (Cross-Site Scripting) zafiyetine yol açabilir. 
          Verinin güvenilir bir kaynaktan geldiğinden emin olun.
        */}
        <article
          className="prose prose-invert max-w-none prose-lg prose-p:leading-relaxed prose-a:text-indigo-400 hover:prose-a:text-indigo-300"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
      </div>
    </div>
  );
};

export default BlogPostPage;